<template>
   

   <div class="row">
        <div class="col-6">
            <div class="form-container mb-3">
                <div class="form-title">Selecionar Assunto</div>
                <div class="row">
                    <div class="col-12 mb-1">
                        <input type="radio" name="rbAssuntoGlossario" v-model="rbAssuntoGlossario" checked />&nbsp;<strong>Assunto</strong>&nbsp;&nbsp;&nbsp;
                        <input type="radio" name="rbAssuntoGlossario" v-model="rbAssuntoGlossario" />&nbsp;<strong>Glossário</strong>
                    </div>
                    
                </div>
                <div class="row">
                    <div class="col-8 form-group mb-1">
                        <input class="form-control" type="text" v-model="pesquisar_assunto" placeholder="Digite aqui sua busca ou percorra os assuntos abaixo" />
                    </div>
                    <div class="col-4 form-group mb-2">
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; cursor: pointer; background-color: white; border: solid 1px lightgray;">
                            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Filtrar</label>
                        </button>
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; cursor: pointer; background-color: white; border: solid 1px lightgray;">
                            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Pesquisar</label>
                        </button>
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; cursor: pointer; background-color: white; border: solid 1px lightgray;">
                            <label style="color: #007BFF; vertical-align: middle; cursor: pointer;" @click="LimparPesquisa">Limpar</label>
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 form-group mt-1 mb-1 text-right" style="text-align: right;">
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; cursor: pointer; background-color: white; border: solid 1px lightgray;">
                            <img :src='BASE_URL+"imagens/icons/assuntos_A_vermelho.png"' />
                        </button>
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; cursor: pointer; background-color: white; border: solid 1px lightgray;">
                            <img :src='BASE_URL+"imagens/icons/assuntos_A_verde.png"' />
                        </button>
                        |
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; cursor: pointer; background-color: white; border: solid 1px lightgray;">
                            <img :src='BASE_URL+"imagens/icons/assuntos_estrelas.png"' />
                        </button>
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; cursor: pointer; background-color: white; border: solid 1px lightgray;">
                            <img :src='BASE_URL+"imagens/icons/assuntos_diretorios.png"' />
                        </button>
                        |
                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; cursor: pointer; background-color: white; border: solid 1px lightgray;">
                            <img :src='BASE_URL+"imagens/icons/assuntos_ordenacao.png"' />
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-11 form-group mb-1" style="height: 350px; overflow: auto;" role="application" aria-label="Lista de assuntos">
                        <ProcessoAssuntoArvoreComponent :assuntos="assuntosFiltrados" :nivel="0" @addSubassunto="PegaAssunto" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 form-group mb-1">
                        <strong>Assunto pode ser o principal?</strong>&nbsp;
                        <input type="radio" name="pode_ser_o_principal" value="1" />&nbsp;Sim&nbsp;&nbsp;
                        <input type="radio" name="pode_ser_o_principal" value="0" />&nbsp;Não
                        <br />
                        <strong>Norma:</strong><br />
                        <textarea class="form-control" id="norma" rows="4" v-model="norma" disabled>
                        </textarea>

                        <strong>Artigo:</strong><br />
                        <input class="form-control" type="text" id="artigo" v-model="artigo" disabled>
                    </div>

                    <div class="col-6 form-group mb-1">
                        <strong>Glossário:</strong><br />
                        <textarea class="form-control" id="glossario" rows="4" v-model="glossario" disabled>
                        </textarea>
                    </div>

                </div>

            </div>
        </div>
        <div class="col-6">
            <div class="row">
                <div class="col-12 form-container mb-3">
                    <div class="form-title">Instruções</div>
                    <ul>
                        <li>- Cadastre por primeiro o assunto principal. É o direito material descrito nos fatos, fundamentos e pedido.</li>
                        <li>- Procure cadastrar os assuntos o mais específico possível. Se necessário, utilize os assuntos complementares para melhor classificação do processo.</li>
                        <li>- Utilize o assunto do ramo do direito adequado ao contexto do processo, especialmente quando houver diferentes assuntos com termos ou expressões idênticas.</li>
                        <li>- Na dúvida consulte as informações dos glossários disponíveis em cada assunto.</li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col-12 form-container mb-3">
                    <div class="form-title">Assuntos Selecionados</div>
                    <span><strong>Assunto Principal:</strong></span>
                    <input class="form-control" type="text" v-model="campo_assunto_principal" 
                    :placeholder="assuntos_selecionados.length > 0 ? 'Selecione outros assuntos' : 'Selecione o assunto principal e clique em \'Incluir\' '" 
                    disabled /><br />
                    <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; cursor: pointer; background-color: white; border: solid 1px lightgray;" @click="IncluirAssunto">
                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Incluir</label>
                    </button>
                    <button type="button" class="btn btn-sm btn-light" style="margin-right: 2px; cursor: pointer; background-color: white; border: solid 1px lightgray;" @click="LimparAssunto">
                        <label style="color: #007BFF; vertical-align: middle; cursor: pointer;">Limpar</label>
                    </button>
                    <br />
                    <br />
                    <div class="card-body mb-2" v-if="assuntosPrincipais.length > 0">
                        <table class="table table-striped table-bordered mt-2 border">
                            <thead>
                                <tr class="text-center">
                                    <th scope="col" style="background-color: lightgrey; display: none;">id</th>
                                    <th scope="col" style="background-color: lightgrey; width: 70%;">Assunto Principal</th>
                                    <th scope="col" style="background-color: lightgrey; width: 30%;">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="assunto in assuntosPrincipais">
                                    <td style="display: none;">{{ assunto.id }}</td>
                                    <td style="text-align: left;">{{ assunto.id.toString().padStart(5, '0') }} - {{ assunto.descricao }}</td>
                                    <td style="text-align: center;">
                                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 50px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="removerAssunto(assunto.id)">
                                            <img :src='BASE_URL+"imagens/icons/assuntos_remover.png"' width="20px" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        


                        <div class="col-12">
                            <label for="competencia_selecionada"><strong>Competência:</strong></label>
                            <select class="form-control form-control-sm custom-select-sm custom-dropdown"
                                    v-model="competencia_selecionada"
                                    @change="CompetenciaSelectionada(competencia_selecionada)">
                                <option value="">Selecione a competência</option>
                                <option v-for="competencia in competencias"
                                        :key="competencia.id"
                                        :value="competencia.id">
                                    {{ competencia.descricao }}
                                </option>
                            </select>
                        </div>
                        <br />
                        <br />

                    </div>
                    
                    <div class="card-body mb-2" v-if="assuntosNaoPrincipais.length > 0">
                        <table class="table table-striped table-bordered mt-2 border">
                            <thead>
                                <tr class="text-center">
                                    <th scope="col" style="background-color: lightgrey; display: none;">id</th>
                                    <th scope="col" style="background-color: lightgrey; width: 70%;">Demais Assuntos Incluídos</th>
                                    <th scope="col" style="background-color: lightgrey; width: 30%;">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="assunto in assuntosNaoPrincipais">
                                    <td style="display: none;">{{ assunto.id }}</td>
                                    <td style="text-align: left;">{{ assunto.id.toString().padStart(5, '0') }} - {{ assunto.descricao }}</td>
                                    <td style="text-align: center;">
                                        <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 50px; background-color: rgb(235, 234, 234); cursor: pointer;" @click="removerAssunto(assunto.id)">
                                            <img :src='BASE_URL+"imagens/icons/assuntos_remover.png"' width="20px" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                </div>
            </div>
        </div>
   </div>

</template>
  
  <script>

import axios from 'axios';
import ProcessoAssuntoArvoreComponent from './ProcessoAssuntoArvoreComponent.vue';
  
  export default {
    data() {
        return {
            selectedFile: null,
            BASE_URL: window.Laravel.baseUrl,
            rbAssuntoGlossario: '',
            pesquisar_assunto: '',
            assuntos: [],
            artigo: '',
            norma: '',
            glossario: '',
            campo_assunto_principal: '',
            assunto_principal_selecionado: '',
            assuntos_selecionados: [],

            competencias: [],
            competencia_selecionada: '',
        };
    },
    methods: {
        CarregarCompetencias(){
            axios.get(this.BASE_URL + 'buscar/competencias')
            .then(response => {
                this.competencias = response.data;
            })
            .catch(error => {
                console.error('Erro ao buscar informações os assuntos:', error);
            });
        },
        async CompetenciaSelectionada(competencia_selecionada){
            try {

                if(competencia_selecionada == ''){
                    return;
                }

                let processoId = this.$store.state.processo.id;
                
                const response = await axios.post(this.BASE_URL + 'processo_atualiza_competencia', {
                    processoId: processoId,
                    competencia_selecionada: this.competencia_selecionada,
                });

                console.log('Competencias atualizada.');
                console.log(response.data);

                this.$store.commit('setProcessoCompetencia', this.competencia_selecionada);
                
                
            } catch (error) {
                console.error('Erro ao atualizar o interesse de conciliação.', error);
            }
        },
        CarregarAssuntos(){
                axios.get(this.BASE_URL + 'buscar/assuntos')
                .then(response => {
                    this.assuntos = response.data;
                })
                .catch(error => {
                    console.error('Erro ao buscar informações os assuntos:', error);
                });
        },
        CarregarAssuntosVinculados(){
                let processoId = this.$store.state.processo.id;

                if(processoId != undefined) {
                    axios.get(this.BASE_URL + 'buscar/assuntos_vinculados', {
                            params: {
                                    processo_id: processoId, // Isso assegura que `processo_id` é enviado como parâmetro da query
                                }
                        })
                        .then(response => {
                            
                            response.data.forEach(item => {
                                let principal_aux = (item.pivot.assunto_principal == 1) ? true : false;
                                var objetoParaAdicionar = { 
                                    id: item.id, 
                                    descricao: item.descricao, 
                                    principal: principal_aux
                                };
                                this.assuntos_selecionados.push(objetoParaAdicionar);
                            });
                        })
                        .catch(error => {
                            console.error('Erro ao buscar informações os assuntos:', error);
                        });
                }
        },
        PegaAssunto(assuntoId, assuntoDescricao) {
            this.assunto_principal_selecionado = assuntoId;
            this.campo_assunto_principal = assuntoDescricao;
        },
        
        IncluirAssunto() {
            if(this.campo_assunto_principal == ''){
                alert("Nenhum assunto selecionado.");
                return;
            }

            let principal = false;
            if(this.assuntos_selecionados.length == 0){
                principal = true;
            }

            var objetoParaAdicionar = { 
                id: this.assunto_principal_selecionado, 
                descricao: this.campo_assunto_principal, 
                principal: principal 
            };
            
            let assuntoExistente = this.assuntos_selecionados.find(assunto => assunto.id === objetoParaAdicionar.id); //Verifica se o assunto já existe no array
            
            if (!assuntoExistente) { //Se não existir, adiciona ao array
                this.assuntos_selecionados.push(objetoParaAdicionar);
                this.LimparAssunto();
                this.sincronizarAssuntos();
            } else {
                alert("Assunto já adicionado.");
            }
        },
        removerAssunto(assuntoId) {
            const assuntoPrincipal = this.assuntos_selecionados.find(assunto => assunto.id === assuntoId);

            if (assuntoPrincipal && assuntoPrincipal.principal) { // Se o assunto a ser removido for o principal, limpa todo o array
                this.assuntos_selecionados = [];
            } else {
                this.assuntos_selecionados = this.assuntos_selecionados.filter(assunto => assunto.id !== assuntoId); // Caso contrário, remove apenas o assunto específico
            }
            this.sincronizarAssuntos();
        },

        sincronizarAssuntos() {
            let processoId = this.$store.state.processo.id;

            axios.post(this.BASE_URL + 'processo-assuntos/sincronizar', {
                processo_id: processoId, // Assuma que `processoId` é o ID do processo atual
                assuntos: this.assuntos_selecionados
            })
            .then(response => {
                //console.log('Sincronização de assuntos do processo ' + processoId + ' bem-sucedida' + response.data);
                this.$store.commit('setProcessoAssuntos', this.assuntos_selecionados); //Adicionar os assuntos na variável global do processo.
            })
            .catch(error => {
                //console.error('Erro na sincronização', error);
            });
        },
        LimparAssunto(){
            this.campo_assunto_principal = '';
        },
        LimparPesquisa(){
            this.pesquisar_assunto = '';
        },

        filtrarAssuntos(assuntos, termoDeBusca) {
            const termoLowerCase = termoDeBusca.toLowerCase();

            function filtrar(array) {
                return array
                    .map((assunto) => {
                    // Cópia do assunto atual
                    const copiaAssunto = { ...assunto };

                    // Filtra os filhos, se houver
                    if (copiaAssunto.children) {
                        copiaAssunto.children = filtrar(copiaAssunto.children);
                    }

                    // Verifica se o assunto ou qualquer um dos seus filhos corresponde à pesquisa
                    const correspondeBusca = copiaAssunto.descricao.toLowerCase().includes(termoLowerCase) ||
                                            (copiaAssunto.children && copiaAssunto.children.length > 0);

                    return correspondeBusca ? copiaAssunto : null;
                    })
                    .filter((assunto) => assunto !== null); // Remove os nulos
            }
            return filtrar(assuntos);
        },

        
    },
    mounted() {
        this.CarregarAssuntos();
        this.CarregarAssuntosVinculados();
        this.CarregarCompetencias();
    },
    computed: {
        assuntosPrincipais() {
            return this.assuntos_selecionados.filter(assunto => assunto.principal === true);
        },
        assuntosNaoPrincipais() {
            return this.assuntos_selecionados.filter(assunto => assunto.principal === false);
        },
        assuntosFiltrados() {
            if (!this.pesquisar_assunto) {
            return this.assuntos; // Retorna todos os assuntos se não houver termo de busca
            }
            return this.filtrarAssuntos(this.assuntos, this.pesquisar_assunto); // Filtra os assuntos com base no termo de busca
        },
        
    }
  };
  </script>
  
<style scoped>
 
.form-container {
    border: 1px solid gray; /* Borda fina cinza */
    padding: 10px;
    position: relative; /* Posição relativa para o posicionamento do título */
    margin-top: 5px; /* Espaçamento superior para visualização do título */
    margin-left: 5px;
    margin-right: 5px;
    border-radius: 5px;
    background-color: #FFFFFF;
}

.form-title {
    position: absolute; /* Posicionamento absoluto do título */
    top: -15px; /* Posiciona o título acima da borda */
    left: 10px; /* Espaçamento da esquerda para o título */
    background: white; /* Fundo branco para o título */
    padding: 0 1px; /* Espaçamento interno do título */
    font-weight: bold;;
}

ul {
  padding-left: 0; /* Opcional: remove o padding padrão */
  list-style-type: none;
}

</style>
  
